import React, { useEffect, useMemo, useState } from "react";
import { Table, Input, Button, Tooltip, Space, Spin, Popconfirm } from "antd";
import {
  CheckCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import getAllAdmin from "../../../hooks/getAllAdmin";
import deleteItem from "../../../hooks/admin/deleteItem";
import updateData from "../../../hooks/admin/updateData";

const { Search } = Input;

const Vendors = () => {
  const { t } = useTranslation();
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState("");

  const filteredItems = useMemo(() => {
    return vendors.filter(
      (item) =>
        item.vendor_name.toLowerCase().includes(filterText.toLowerCase()) ||
        item.vendor_email.toLowerCase().includes(filterText.toLowerCase())
    );
  }, [vendors, filterText]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const res = await getAllAdmin("admin/getallvendor");
      if (res.status_code === 200) {
        setVendors(res.data);
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  const changeVendorStatus = async (id, status) => {
    setLoading(true);
    const newStatus = status ? 0 : 1;

    const res = await updateData("admin/updatevendor", {
      vendor_id: id,
      status: newStatus,
    });

    if (res.status_code === 200) {
      toast.success(res.message);
      setVendors((prev) =>
        prev.map((v) =>
          v.vendor_id === id ? { ...v, status: newStatus } : v
        )
      );
    }
    setLoading(false);
  };

  const handleDelete = (id) => {
    deleteItem(
      id,
      vendors,
      setVendors,
      filteredItems,
      "vendor_id",
      "admin/deletevendor"
    );
  };

  const columns = [
    {
      title: t("Vendor_Name"),
      dataIndex: "vendor_name",
      key: "vendor_name",
      sorter: (a, b) => a.vendor_name.localeCompare(b.vendor_name),
    },
    {
      title: t("form_email"),
      dataIndex: "vendor_email",
      key: "vendor_email",
      sorter: (a, b) => a.vendor_email.localeCompare(b.vendor_email),
    },
    {
      title: t("l_phone"),
      dataIndex: "vendor_contact",
      key: "vendor_contact",
    },
    {
      title: t("Joined_Date"),
      dataIndex: "created_on",
      key: "created_on",
      render: (text) => moment(text).format("DD-MMM-YYYY"),
      sorter: (a, b) => new Date(a.created_on) - new Date(b.created_on),
    },
    {
      title: t("all_product_dataTable6"),
      key: "actions",
      render: (_, item) => (
        <Space>
          <Tooltip title={t("Edit")}>
            <Link to={`/admin/vendor/edit/${item.vendor_id}`}>
              {/* <button
                shape="circle"
                icon={}
                className=""
                size="small"
              /> */}
              <EditOutlined />
            </Link>
          </Tooltip>

          <Tooltip title={t("Delete")}>
            <span
              onClick={() =>
                deleteItem(
                  item.vendor_id,
                  vendors,
                  setVendors,
                  filteredItems,
                  "vendor_id",
                  "admin/deletevendor"
                )
              }
            >
              <Button size="small" danger icon={<DeleteOutlined />} />
            </span>
          </Tooltip>
          {/* </Popconfirm> */}

          <Tooltip
            title={item.status === 0 ? t("unsuspend") : t("Suspend")}
          >
            <Button
              shape="circle"
              icon={
                item.status === 0 ? (
                  <CheckCircleOutlined />
                ) : (
                  <MinusCircleOutlined />
                )
              }
              size="small"
              onClick={() => changeVendorStatus(item.vendor_id, item.status)}
              style={{
                color: item.status === 0 ? "green" : "red",
                borderColor: item.status === 0 ? "green" : "red",
              }}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <>
      <h2 className="text-title text-lg md:text-2xl py-2">{t("Vendors")}</h2>

      <div className="dashboard-box">
        <div className="mb-4 flex justify-between flex-wrap gap-2 p-4">
          <Search
            placeholder={t("Filter_by_name")}
            allowClear
            enterButton
            onSearch={(value) => setFilterText(value)}
            onChange={(e) => setFilterText(e.target.value)}
            style={{ maxWidth: 300 }}
          />
        </div>

        <Spin spinning={loading}>
          <Table
            columns={columns}
            dataSource={filteredItems}
            rowKey="vendor_id"
            pagination={{ pageSize: 10 }}
          />
        </Spin>
      </div>
    </>
  );
};

export default Vendors;
